﻿import Common from './i247.Common.js';
import TyresForm from './Tyres/tyres.js';
import { _utilities } from './utilities.js';

export let _serviceBooking;
export let _tyresForm;

let vehicleLookup;

export default class VehicleLookup {
	constructor() {
		// local fields
		this._vehicle = undefined;

		// Class initialization
		this.BindFormControls();

		if ($('#ServiceIdentifier').val() === 'TYRES') {
			_tyresForm = new TyresForm();
		}
	}

	// --------------------------------------------------
	// GETTER AND SETTER
	// --------------------------------------------------

	get Vehicle() {
		return this._vehicle;
	}

	set Vehicle(newVehicle) {
		this._vehicle = newVehicle;
	}

	// --------------------------------------------------
	// FUNCTIONS
	// --------------------------------------------------

	BindFormControls() {
		let _this = this;
		if ($('#ServiceIdentifier').val()) {
			$('#vehicle-search-input').focus();
		} else {
			$('#Registration').focus();
		}

		$('.i247service .fa-info-circle').click(function () {
			var windowText = $(this).data('infotext');
			var windowTitle = $(this).data('infotitle');
			var infoWindow = $('#infoWindow').kendoWindow({
				width: 'auto',
				height: 'auto',
				position: {
					top: 100
				}
			}).data('kendoWindow');
			infoWindow.title(windowTitle);
			infoWindow.content(windowText);
			infoWindow.center().open();
		});

		$('#ButtonSearchAgain').click(function () {
			$('#PrivacyStatement').hide();
			$('#SearchAgain').hide();
			$('#ServiceList').hide();
			$('#ServicesHeader').hide();
			$('#SearchForm').show();
		});

		$('#PrivacyCheckBox').change(function () {
			if ($(this).is(':checked')) {
				_this.BindServiceButtons(true);
			} else {
				_this.BindServiceButtons(false);
			}
		});
	};

	GetVehicle(vehicleRegistration, grecaptcharesponse) {
		let result = $.Deferred();

		// send the q as well, which has the customer id in it to filter the vehicles returned.
		let queryString = Common.GetQueryStringValue('q', null);
		let url = '/vehicle/GetVehicle?q=' + queryString + '&vehicleRegistration=' + vehicleRegistration + '&grecaptcharesponse=' + grecaptcharesponse;

		$.ajax({
			url: url,
			type: 'GET',
			cache: false,
			success: (data) => {
				result.resolve(data);
			},
			error: (xhr, ajaxOptions, thrownError) => {
				console.log(xhr.status);
				console.log(xhr.responseText);
				console.log(thrownError);
				kendo.ui.progress($('body'), false);
				Common.ShowGenericError();
			}
		});

		return result.promise();
	};

	GetVehicleServices(vehicleRegistration) {
		var result = $.Deferred();
		var url = '/vehicle/GetServices?vehicleRegistration=' + vehicleRegistration;
		$.ajax({
			url: url,
			type: 'GET',
			cache: false,
			success: function (data) {
				result.resolve(data);
			},
			error: function (xhr, ajaxOptions, thrownError) {
				console.log(xhr.status);
				console.log(xhr.responseText);
				console.log(thrownError);
				kendo.ui.progress($('body'), false);
				Common.ShowGenericError();
			},
			complete: function () {
			}
		});

		return result.promise();
	};

	DoLookup(registration, grecaptcharesponse) {
		let _this = this;
		var serviceIdentifier = $('#ServiceIdentifier').val();

		// Retrieve from Site Settings
		var canCreateNewBookingWithExistingBooking = JSON.parse($('#CanCreateNewBookingWithExistingBooking').val());

		$.get("tyres/CustomerLink")
			.fail(function () {
				Common.ShowGenericError();
			})
			.done(function (customer) {

				if (serviceIdentifier) {
					kendo.ui.progress($('body'), true);

					Common.HideUserMessage();

					const registration = $('#vehicle-search-input').val().replace(' ', '').toUpperCase();

					var vehicleNotFoundMessage = '';

					switch (subdomain) {
						case 'novuna':
							vehicleNotFoundMessage = `<p>Sorry no details are currently held on our system for registration ${registration}.</p><p>You may want to check the registration entered.</p><p>Please check this is a Novuna vehicle. If you still encounter issues please call your Driverline and select the option for tyres where one of the team will be able to assist.</p><p><a class="btn btn-success" href="/">Try again</a></p>`;
							break;

						case 'mfs':
							vehicleNotFoundMessage = `<p>Sorry no details are currently held against registration ${registration}.</p><p>Please check this is a Babcock vehicle and then contact the tyre team on <a href="tel:01202611567">01202 611567</a> where one of the team will be able to assist.</p><p>You may want to check the registration entered.</p><p><a class="btn btn-success" href="/">Try again</a></p>`;
							break;

						default:
							var customerName = '';
							switch (customer.name) {
								case 'Micheldever':
									customerName = "Micheldever Fleet Solutions";
									break;

								case 'Vms':
									customerName = "VMS";
									break;

								case 'Omodaandjaecoo':
									customerName = "Omoda and Jaecoo Contract Hire"
									break;

								case 'Mg':
									customerName = 'MG Contract Hire';
									break;

								case 'Hyundai':
									customerName = 'Hyundai Contract Hire';
									break;

								case 'Honda':
									customerName = 'Honda Contract Hire';
									break;

								case 'Byd':
									customerName = "BYD";
									break;

								default:
									customerName = customer.name;
									break;
							}
							vehicleNotFoundMessage = `<p>Sorry no details are currently held against registration ${registration}.</p><p>Please check this vehicle is covered for tyres through ${customerName} then call your Driverline and select the option for tyres where one of the team will be able to assist.</p><p>You may want to check the registration entered.</p><p><a class="btn btn-success" href="/">Try again</a></p>`;
							break;
					}

					_this.GetVehicle(registration, grecaptcharesponse).done((vehicle) => {
						if (!vehicle) {
							Common.ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage, true);
							kendo.ui.progress($('body'), false);
							return;
						} else {
							var message = '';
							var title = '';
							var showCreateBookingWarning = false;
							if (vehicle.existingBooking && !_utilities.IsMfs()) {
								if (canCreateNewBookingWithExistingBooking) {
									showCreateBookingWarning = true;
									kendo.ui.progress($('body'), false);
									$('#existing-booking-found-for-vehicle-message').show();
								} else {
									message = 'It appears we’ve already received an appointment request for this vehicle which our team are attempting to coordinate with our approved garages. Please rest assured the team will be in contact shortly with confirmation once a booking has been secured that can facilitate the work requirements and appointment preferences. If you’d like to alter this appointment please call your Driverline. Thank you for your patience.';
									title = 'Existing Booking';
								}
							} else if (_utilities.IsMfs()) {
								var validClassList = ['car', 'lcv'];

								if (!vehicle.class || !validClassList.includes(vehicle.class.toLowerCase())) {
									message = 'We are unable to process this request online, please call 01202 611567.';
									title = 'Please Call Us';
								}
							}

							_tyresForm.disableMoveNext = showCreateBookingWarning;

							if (message.length > 0) {
								Common.ShowUserMessage(title, message, true);
								kendo.ui.progress($('body'), false);
								return;
							}
						}

						_this.Vehicle = vehicle;

						if (!_this.Vehicle.maintained || (_this.Vehicle.maintained && _this.Vehicle.maintained.toUpperCase() != 'Y')) {
							$('#no-tyre-services-found-for-vehicle-message').show();
							$('#ServicesHeader').hide();
							kendo.ui.progress($('body'), false);
						} else {
							_this.GetVehicleServices(_this.Vehicle.registration).done(function (services) {
								if (services.length === 0 || services.indexOf(serviceIdentifier) === -1) {
									switch (subdomain) {
										case 'omodaandjaecoo':
										case 'mg':
										case 'hyundai':
										case 'honda':
										case 'byd':
											$('#no-tyre-services-found-for-vehicle-message').show();
											break;

										default:
											$('#no-services-found-for-vehicle-message').show();
											break;
									}
									$('#ServicesHeader').hide();
									kendo.ui.progress($('body'), false);
								} else {
									$('#ServicesHeader').show();
									$('#no-services-found-for-vehicle-message').hide();

									if (serviceIdentifier === 'TYRES') {
										kendo.ui.progress($('body'), false);
										_tyresForm.setVehicle(_this.Vehicle);
										_tyresForm.initialiseVehicleModel();
									}
								}
							});
                        }
					});
				} else {
					$('#PrivacyCheckBox').attr('checked', false);

					kendo.ui.progress($('body'), true);

					Common.HideUserMessage();
					$('#ServicesHeader').hide();
					$('#ServiceList').hide();

					_this.GetVehicle(registration, grecaptcharesponse).done(function (vehicles) {
						if (!vehicle) {
							Common.ShowUserMessage('Vehicle Not Found', vehicleNotFoundMessage, true);
							kendo.ui.progress($('body'), false);
							return;
						}

						var selectedServiceUrl = $('#SelectedServiceUrl').val();
						if (selectedServiceUrl !== '') {
							window.location = selectedServiceUrl;
							return;
						}

						_this.Vehicle = vehicles[0];

						_this.GetVehicleServices(_this.Vehicle.registration).done(function (services) {
							kendo.ui.progress($('body'), false);

							$('.i247service').hide();
							$('#SearchAgain').hide();
							$('#ServiceList').hide();
							$('#PrivacyStatement').hide();

							if (services.length === 0) {
								Common.ShowUserMessage('Unable to Proceed', `<p>We could not find any services associated with vehicle registration ${_this.Vehicle.registration}.</p><p>Please call your dedicated Driverline for assistance.</p>`, true);
								return;
							} else {
								$('#PrivacyStatement').show();
								$('#ServicesHeader').show();
								$('#HeaderRegistration').text(registration.toUpperCase());
								$('#HeaderVehicleMake').text(_this.Vehicle.manufacturer);
								$('#HeaderVehicleDescription').text(_this.Vehicle.description);
								$('#HeaderVehicleLeaseCompany').text(_this.Vehicle.customerName);
								$('#HeaderVehicleDriverCompany').text(_this.Vehicle.driverCompanyName);
								$('#SearchAgain').show();
								$('#SearchForm').hide();
							}

							$.each(services, function (i, service) {
								var selector = '#DIV' + service.toUpperCase();
								$(selector).show();
							});
						});
					});
				}
			});
	};

	BindServiceButtons(ShowService) {
		$('.i247service .gobutton').unbind('click');

		if (ShowService) {
			$('#ServiceList').slideDown();
			$('.i247service .gobutton').click(function () {
				window.location = $(this).data('url');
			});
		} else {
			$('#ServiceList').slideUp();
			$('.i247service .gobutton').click(function () {
				if (!$('#PrivacyCheckBox').is(':checked')) {
					$('#PrivacyCheckBox').kendoTooltip({
						width: 240,
						position: 'top',
						animation: {
							open: {
								effects: 'zoom',
								duration: 150
							}
						}
					}).data('kendoTooltip').show();
				}
			});
		}
	}
};

// Google Captcha Callback (Needs to be in global scope)
function RecaptchaCallBack(result) {
	let validator = $('#VehicleSearchFormContainer').kendoValidator().data('kendoValidator');
	Common.BindValidationStyles(validator);

	let recaptchaResponse = grecaptcha.getResponse();

	if (!validator.validate()) return;

	let registration = $('#Registration').val();

	if ($('#ServiceIdentifier').val()) {
		registration = $('#vehicle-search-input').val();
	}
	registration = registration.replace(' ', '');

	grecaptcha.reset();
	vehicleLookup.DoLookup(registration, recaptchaResponse);
};

$(function () {
	vehicleLookup = new VehicleLookup();

	window.grecaptcha.ready(() => {
		grecaptcha.render('vehicle-search-button', {
			'sitekey': '6LecsgkbAAAAAB6gO3yIsno1RUQoGE3VXB3rEjX3',
			'callback': RecaptchaCallBack
		})
	});
});